<template>
    <div class="event-screen">
        <vue-custom-scrollbar ref="customScrollbar" class="event-details event">
            <div class="header">
                <i class="back" @click="closeSpot"></i>
            </div>

            <div class="main-box" v-if="spot" :id="`event-${spot.id}`">
                <div class="photo event"
                    v-if="spot.photo_small"
                    @click="displayEventPhoto(defaultPhoto)"
                    :style="{'background': `url(${spot.photo_orig}) no-repeat center / cover`}">
                </div>
                <div class="main-box-footer">
                    <div class="inner">
                        <div class="info" :class="{'was-online': spot.wasRecentlyOnline && !spot.isOnline, 'online': spot.isOnline && spot.type !== 'guide'}">
                            <div class="name">
                                {{ spot.title }}
                            </div>
                            <div class="notranslate">@{{spot.handle}}</div>
                        </div>
                        <div class="details event">
                            <div class="location notranslate" v-if="spot.address">{{spot.address }}</div>
                            <div class="location notranslate" v-else>BUDDYWOOD</div>
                            <div class="website" v-if="spot.public_url">
                              <a :href="getEventWebsite" target="_blank">{{ spot.public_url }}</a>
                            </div>
                            <div class="description" v-html="spot.description"></div>
                            <div class="tags" v-if="spot.spot_tags && spot.spot_tags.length">
                                <div class="tag notranslate" v-for="tag in spot.spot_tags"><span>{{ tag.name }}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="func-buttons event">
                      <button type="button" v-if="isMyEvent(spot)"
                              @click="editSpot(spot.id)"
                              class="edit-button btn">
                        {{ trans('edit') }}
                      </button>
                    </div>
                </div>
            </div>
        </vue-custom-scrollbar>
    </div>
</template>

<script>
    import _ from 'lodash';
    import {mapState, mapActions, mapGetters} from 'vuex';
    import CustomReveal from '@buddy/views/widgets/CustomReveal.vue';
    import UserPhotosReveals from '@buddy/views/widgets/UserPhotosReveals.vue';
    import UserVideosReveals from '@buddy/views/widgets/UserVideosReveals.vue';
    import EditEvent from '@events/views/desktop/event/Edit.vue';

    import chatModule from '@chat/module/store/type'
    import eventsModule from '@events/module/store/type'

    // custom scrollbar
    import vueCustomScrollbar from 'vue-custom-scrollbar'
    import "vue-custom-scrollbar/dist/vueScrollbar.css"

    export default {
        mixins: [
            require('@general/lib/mixin').default,
            require('@general/lib/mixin-chat').default,
            require('@general/lib/mixin-events').default,
        ],
        props: ['id'],
        data() {
            return {
                menuVisible: false,
                reportMenuVisible: false,
                reportData: [],
            }
        },
        components: {
            CustomReveal,
            UserPhotosReveals,
            UserVideosReveals,
            EditEvent,
            vueCustomScrollbar
        },
        computed: {
            ...mapState({
                user: 'profile',
                userIsPro: 'userIsPro',
            }),
            ...mapGetters({
                spotData: eventsModule.getters.spot,
                unreadEventMessagesCount: chatModule.getters.messages.count.unreadEvent
            }),
            spot(){
                return this.$store.getters.getSpot(this.spotData.id)
            },
            getEventWebsite() {
                return this.spot.public_url.startsWith('https://') || this.spot.public_url.startsWith('http://') ? this.spot.public_url : `//${this.spot.public_url}`
            },
            photos() {
                return this.spot && this.spot.photos && this.spot.photos.filter(v => v.pivot.is_default == 'no');
            },
            videos() {
                return this.spot && this.spot.videos;
            },
            defaultPhoto() {
              return this.spot.photos.find(v => v.pivot.is_default == 'yes');
            }
        },
        methods: {
            ...mapActions({
                reportEvent: eventsModule.actions.events.report,
                toggleEventLike: eventsModule.actions.events.like
            }),
            addLike(event){
              if(this.showJoinModalIfNeed()){
                return false;
              }
              this.toggleEventLike(event)
            },
            hideMenu(){
                this.hideReportMenu()
                this.menuVisible = false
            },
            showReportMenu() {
                this.reportMenuVisible = true
            },
            hideReportMenu() {
                this.reportMenuVisible = false
            },
            closeFilter() {
                this.hideReportMenu();
            },
            sendEventReport(reason) {
                this.reportEvent({
                    reason: this.reportData,
                    id:       this.spot.id,
                    callback: this.eventReportResponse,
                })
            },
            eventReportResponse(response) {
                if (response.data.success) {
                    this.showSuccessNotification(response.data.trans)
                } else {
                    this.showErrorNotification(response.data.trans)
                }
                this.closeFilter()
            },
            displayEventPhoto(photo) {
                if (photo !== undefined) {
                    app.$emit('show-view-photo-reveal', photo.id);
                }
            },
            displayEventVideo(video) {
                if (video !== undefined) {
                    app.$emit('show-view-video-reveal', video.id);
                }
            },
            openUser(userId) {
                this.closeEvent()
                this.openUserModal(userId, 7)
            },
        },
        mounted() {
            if (this.$refs.customScrollbar) {
              this.$refs.customScrollbar.$forceUpdate()
            }
        }
    }
</script>
